import { Component, OnInit } from '@angular/core';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';

interface NavigationNode {
  name: string;
  route: string;
  children?: NavigationNode[];
}

const TREE_DATA: NavigationNode[] = [
  {
    name: 'Downloads',
    route: 'downloads',
  }, 
];

@Component({
  selector: 'app-cspondemand-navigation',
  templateUrl: './cspondemand-navigation.component.html',
  styleUrls: ['./cspondemand-navigation.component.css']
})
export class CspondemandNavigationComponent {
  treeControl = new NestedTreeControl<NavigationNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<NavigationNode>();

  constructor() {
    this.dataSource.data = TREE_DATA;
  }

  hasChild = (_: number, node: NavigationNode) => !!node.children && node.children.length > 0;
}

